import { cn } from '@core-utils/cn';
import { forwardRef } from 'react';

import styles from './Form.module.scss';

type FormActionControlProps = React.HTMLAttributes<HTMLDivElement>;

const FormActions = forwardRef<HTMLDivElement, FormActionControlProps>(
    function FormActions({ className, ...props }, ref) {
        return (
            <div
                ref={ref}
                className={cn(styles.FormActions, className)}
                {...props}
            />
        );
    },
);

export { FormActions };
